import React from 'react';

const FormControl = ({ children }) => {
    return <div style={{ marginBottom: '20px' }}>{children}</div>;
};

export default FormControl;
